export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const LANDING = '/';
export const HOME = '/home';
export const ACCOUNT = '/account';
export const PASSWORD_FORGET = '/pw-forget';
export const PASSWORD_RESET = '/pw-reset';
export const PICKS = '/picks'
export const CREATE = '/new-picks'
export const FUND = '/fund'
export const BLANK = '/'
export const ADMIN = '/admin'
export const WELCOME = '/welcome'
export const ERROR = '/error'
export const SUCCESS = '/success'
export const NEW = '/new'

export const INTAKE_FORM = '/requestProposal'


export const API_SAVE_USER = '/saveUser'
export const API_GET_USER = '/getUser'


// WEBPACK FOOTER //
// ./src/config/routes.js